import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT_CALIBRATION_CONTROL,
  ENDPOINT_CALIBRATION_HISTORY,
  ENDPOINT_CALIBRATION_HISTORY_DETAIL,
  ENDPOINT_HISTORIC_LAST_STATUS_CALIBRATION,
  ENDPOINT_LAST_STATUS_CALIBRATION,
  ENDPOINT_RANGE_SCORE,
} from './constants';

export function useNotesRangeService() {
  const { backendGet, backendPatch, backendPut } = Sebrae.useBackend();

  const listNotesRange = React.useCallback(
    () => backendGet(`${ENDPOINT_RANGE_SCORE}`),
    [backendGet],
  );

  const calibrationHistory = React.useCallback(
    () => backendGet(`${ENDPOINT_CALIBRATION_HISTORY}`),
    [backendGet],
  );

  const calibrationHistoryDetail = React.useCallback(
    (ids) => backendGet(`${ENDPOINT_CALIBRATION_HISTORY_DETAIL}/${ids}`),
    [backendGet],
  );

  const getLastStatusCalibration = React.useCallback(
    () => backendGet(`${ENDPOINT_LAST_STATUS_CALIBRATION}`),
    [backendGet],
  );

  const listStatusCalibration = React.useCallback(
    () => backendGet(`${ENDPOINT_HISTORIC_LAST_STATUS_CALIBRATION}`),
    [backendGet],
  );

  const updateRangeList = React.useCallback(
    (rangeList) => backendPatch(`${ENDPOINT_RANGE_SCORE}`, rangeList),
    [backendPatch],
  );

  const updateStatusCalibration = React.useCallback(
    () => backendPut(`${ENDPOINT_CALIBRATION_CONTROL}`),
    [backendPut],
  );

  return {
    listNotesRange,
    calibrationHistory,
    calibrationHistoryDetail,
    updateRangeList,
    getLastStatusCalibration,
    listStatusCalibration,
    updateStatusCalibration,
  };
}
